let refreshingPromise = null;

export const TokenManager = {
    accessToken: null,
    refreshToken: null,

    getAccessToken() {
        return this.accessToken;
    },

    async refreshTokenIfNeeded(BaseRequestClass) {
        if (!refreshingPromise) {
            const baseRequest = new BaseRequestClass('customer');

            refreshingPromise = baseRequest
                .refreshToken()
                .then((response) => {
                    if (response.results.length > 0) {
                        const newAccessToken = response.results[0].access_token;
                        const newRefreshToken =
                            response.results[0].refresh_token;

                        return newAccessToken;
                    } else {
                        throw new Error('Refresh token failed');
                    }
                })
                .finally(() => {
                    refreshingPromise = null;
                });
        }

        return refreshingPromise;
    },
};
